import React from 'react';
import type EventCache from 'utils/EventCache/EventCache';
import { type PlaylistCache } from 'utils/PlaylistCache/PlaylistCache';
import type SegmentCache from 'utils/PlaylistCache/SegmentCache';

// Import only React and types here. HMR then never re-runs this module, so CacheProvider and its consumers keep the same context object.
export const CacheContext = React.createContext<
  | {
      playlistCache: PlaylistCache;
      segmentCache: SegmentCache;
      eventCache: EventCache;
    }
  | undefined
>(undefined);
CacheContext.displayName = 'CacheContext';
